// extracted by mini-css-extract-plugin
export default {"WarningComponent":"styles_WarningComponent__Wo4VA","WarningComponentHeaderDiv":"styles_WarningComponentHeaderDiv__k6H4e","DescriptionText":"styles_DescriptionText__jRDTY"};